module.exports = __webpack_public_path__ + "static/bg_dod-2dfab2a8b517928a304ac85734afd368.jpg";